// Cell text for "Compare every feature" (src/components/pricing2026/CompareFeatures.tsx): a plans.ts COMPARE_SECTIONS
// value cell in the page's language. ✓ / not-included cells (booleans) have no text: null.

import { fill, formatCount, formatStorage, formatUsd, type PricingCopy } from "@/content/pricing";
import type { CompareCell } from "@/content/pricing/plans";
import { ratePercent } from "@/lib/pricing/orderFee";

/** "{rate}" → a percentage, "{storage}" (from vars.storageGb) → GB / TB, "{usd}" → dollars without the "$" (the
 *  copy places it), anything else → a number in the language's format. */
export function cellText(cell: CompareCell, copy: PricingCopy, numberLocale: string): string | null {
  if (typeof cell === "boolean") return null;
  const vars: Record<string, string> = {};
  for (const [k, n] of Object.entries(cell.vars ?? {})) {
    if (k === "rate") vars.rate = ratePercent(n, numberLocale);
    else if (k === "storageGb") vars.storage = formatStorage(n, copy, numberLocale);
    else if (k === "usd") vars.usd = formatUsd(n, numberLocale).replace(/^\$/, "");
    else vars[k] = formatCount(n, numberLocale);
  }
  return fill(copy.pricing.compare.values[cell.value], vars);
}
